import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Container } from "react-bootstrap";
import { loadWeek, saveWeek } from "../../lib/api/week";
//import { EmptyBlank } from "../../components/common";
import { WeekDetailForm } from "../../components/week/WeekDetailForm";
import { EmptyBlank } from "../../components/common";

const Detail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [week, setWeek] = useState();
  const [state, setState] = useState("none");
  const [auth, setAuth] = useState({
    code: "0000",
    beginDate: Date.now(),
    endDate: Date.now(),
  });
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [unusedQuests, setUnusedQuests] = useState([]);
  const [unusedStudents, setUnusedStudents] = useState([]);
  const [btnSaveDirty, setBtnSaveDirty] = useState(false);

  const requestLoadWeek = useCallback(async () => {
    //const { status, data, message } = await loadWeek({ id: id });
    const { data } = await loadWeek({ id: id });
    setWeek(data);
  }, [id]);

  useEffect(() => {
    requestLoadWeek();
  }, [requestLoadWeek]);

  useEffect(() => {
    try {
      // 상태와 인증
      if (week) {
        setState(week.state);
        setAuth(week.auth);
      }

      if (week && selectedTeam) {
        // 퀘스트들
        const teams = week.teams.filter((x) => x.name === selectedTeam.name);
        if (teams && teams.length > 0) {
          const questIds = teams[0].quests.map((it) => it._id);
          const finalQuests = week.quests.filter(
            (it) => !questIds.includes(it._id)
          );
          setUnusedQuests(finalQuests);
        }
        // 학생들
        let studentIds = [];
        for (const t of week.teams) {
          studentIds = [...studentIds, ...t.students.map((it) => it._id)];
        }
        //console.log("studentIds => ", studentIds);
        const finalStudents = week.students.filter(
          (it) => !studentIds.includes(it._id)
        );
        setUnusedStudents(finalStudents);
      }
    } catch (error) {
      console.log(error);
    }
  }, [week, selectedTeam]);

  const handleState = (e) => {
    console.log("state => ", e.target.value);
    setState((cur) => {
      return e.target.value;
    });
    // 저장 버튼 활성화
    setBtnSaveDirty(true);
  };

  const handleAuth = (e) => {
    const { name, value } = e.target;
    setAuth((cur) => {
      return { ...cur, [name]: value };
    });

    // 저장 버튼 활성화
    setBtnSaveDirty(true);
  };

  const handleSelectTeam = (e) => {
    const teamName = String(e.target.value);
    const teams = week.teams.filter((x) => x.name === teamName);
    if (teams && teams.length > 0) {
      setSelectedTeam(teams[0]);
    }
  };

  const handleAddQuest = (e) => {
    //console.log(`${e.target.value} 퀘스트 추가`);
    const quest = week.quests.find((x) => x._id === e.target.value);
    if (quest && selectedTeam) {
      // 선택한 퀘스트에 추가
      selectedTeam.quests = [...selectedTeam.quests, quest];
      // 대기 목록에서 제거
      setUnusedQuests(unusedQuests.filter((it) => it._id !== quest._id));
    }

    // 저장 버튼 활성화
    setBtnSaveDirty(true);
  };

  const handleRemoveQuest = (e) => {
    //console.log(`${e.target.value} 퀘스트 제거`);
    // 제거하고
    const quest = week.quests.find((x) => x._id === e.target.value);
    selectedTeam.quests = selectedTeam.quests.filter(
      (it) => it._id !== quest._id
    );
    // 대기 목록에 추가
    setUnusedQuests([...unusedQuests, quest]);

    // 저장 버튼 활성화
    setBtnSaveDirty(true);
  };

  const handleAddStudent = (e) => {
    //console.log(`${e.target.value} 학생 추가`);
    const student = week.students.find((x) => x._id === e.target.value);
    if (student && selectedTeam) {
      // 선택한 팀에 추가
      selectedTeam.students = [...selectedTeam.students, student];
      // 대기 목록에서 제거
      setUnusedStudents(unusedStudents.filter((it) => it._id !== student._id));

      // 저장 버튼 활성화
      setBtnSaveDirty(true);
    }
  };

  const handleRemoveStudent = (e) => {
    //console.log(`${e.target.value} 학생 제거`);
    const student = week.students.find((x) => x._id === e.target.value);
    if (student && selectedTeam) {
      // 선택한 팀에 있으면 학생이면
      if (selectedTeam.students.find((it) => it._id === student._id)) {
        // 제거하고
        selectedTeam.students = selectedTeam.students.filter(
          (it) => it._id !== student._id
        );
        // 대기 목록에 추가
        setUnusedStudents([...unusedStudents, student]);

        // 저장 버튼 활성화
        setBtnSaveDirty(true);
      }
    }
  };

  const handleAddTeam = (e) => {
    //console.log(`팀 추가`);
    let teamLastNumber = 0;
    if (week.teams.length > 0) {
      teamLastNumber = Math.max(
        ...week.teams.map((it) => {
          try {
            const strArr = it.name.split("-");
            return parseInt(strArr[strArr.length - 1]);
          } catch {
            return 0;
          }
        })
      );
    }
    const newTeam = {
      name: String(
        `${week.course.courseNumber}-${week.week}-${teamLastNumber + 1}`
      ),
      quests: [],
      students: [],
    };
    week.teams = [...week.teams, newTeam];
    setSelectedTeam(week.teams[week.teams.length - 1]);
    // 저장 버튼 활성화
    setBtnSaveDirty(true);
  };

  const handleRemoveTeam = (e) => {
    //console.log(`${selectedTeam.name} 팀 제거`);
    if (week.teams.length < 1) {
      alert("팀은 최소1개 이상은 존재해야 합니다.");
    } else {
      if (selectedTeam) {
        const team = week.teams.find((it) => it.name === selectedTeam.name);
        if (team) {
          if (window.confirm(`정말 팀[${team.name}]을 삭제하시겠습니까?`)) {
            week.teams = week.teams.filter(
              (it) => it.name !== selectedTeam.name
            );
            setSelectedTeam(week.teams[week.teams.length - 1]);
            // 저장 버튼 활성화
            setBtnSaveDirty(true);
          }
        }
      } else {
        alert("선택되어진 팀이 없습니다.");
      }
    }
  };

  const handleSave = async (e) => {
    console.log(`${id} 주차 저장`);
    //navigate(`/course/${id}`, { replace: true });
    //const { status, data, message } = await saveWeek({ id: id });

    const { status, message } = await saveWeek({
      id: id,
      week: week.week,
      state: state,
      auth: auth,
      teams: week.teams.map((it) => {
        return {
          name: it.name,
          questIds: it.quests.map((st) => {
            return st._id;
          }),
          studentIds: it.students.map((st) => {
            return st._id;
          }),
        };
      }),
    });
    if (status === 200) {
      alert("저장하였습니다.");
    } else {
      alert(message);
    }
  };

  const handleClose = () => {
    navigate(-1);
  };

  return (
    <div>
      <Container fluid="md">
        <WeekDetailForm
          week={week}
          state={state}
          handleState={handleState}
          auth={auth}
          handleAuth={handleAuth}
          selectedTeamName={selectedTeam ? selectedTeam.name : undefined}
          handleSelectTeam={handleSelectTeam}
          handleRemoveQuest={handleRemoveQuest}
          handleRemoveStudent={handleRemoveStudent}
          unusedQuests={unusedQuests}
          unusedStudents={unusedStudents}
          handleAddQuest={handleAddQuest}
          handleAddStudent={handleAddStudent}
          handleAddTeam={handleAddTeam}
          handleRemoveTeam={handleRemoveTeam}
          btnSaveDirty={btnSaveDirty}
          handleSave={handleSave}
          handleClose={handleClose}
        />
        <EmptyBlank />
      </Container>
    </div>
  );
};

export default Detail;
